module.exports = __webpack_public_path__ + "img/collection-engagementRingsDiamond@2x.f031925.webp";